






























import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class SepaDirectDebitCard extends Vue {
  @Prop()
  public last4!: string;

  @Prop({ default: false })
  public isSelected!: boolean;

  @Prop()
  public countryCode!: string;

  @Prop()
  public bankCode!: string;

  public get formattedLast4() {
    return this.last4.substring(0, 2) + ' ' + this.last4.substring(2);
  }
}
